import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';
import { AuthGuardService } from './services/auth-guard.service';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  }, {
    path: 'login',
    loadChildren: './views/login/login.module#LoginModule'
  }, {
    path: '404-not-found',
    loadChildren: './views/error/page-not-found.module#PageNotFoundModule'
  }, {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: 'subscriptionList',
        loadChildren: './views/subscription/subscription.module#SubscriptionModule'
      }
      //PR 966 - START
      , {
        path: 'subscriberList',
        loadChildren: './views/subscriber/subscriber.module#SubscriberModule'
      },
      {
        path: 'userList',
        loadChildren: './views/subscriber-user/subscriber-user.module#SubscriberUserModule'
      }
      //PR 966 - END

      //PR 0983 - START
      , {
        path: 'serviceList',
        loadChildren: './views/service/service.module#ServiceModule'
      }
      //PR 0983 - END

      //PR 922 - START
      , {
        path: 'invoiceList',
        loadChildren: './views/invoice/invoice.module#InvoiceModule'
      }
      //PR 922 - END

      //PR 985 - START
      , {
        path: 'msaList',
        loadChildren: './views/msa/msa.module#MsaModule'
      }
      //PR 985 - START
	  
	  //PR 1066 - START
      , {
        path: 'subscriptionJobsList',
        loadChildren: './views/subscriptionjobs/subscriptionjobs.module#SubscriptionjobsModule'
      }
      //PR 1066 - END
    ]
  }, {
    path: '**',
    redirectTo: '/404-not-found'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
